import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-fields-edit',
  templateUrl: './fields-edit.component.html',
  styleUrls: ['./fields-edit.component.scss'],
})
export class FieldsEditComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  constructor() {}

  ngOnInit() {}

  onBreadcrumbsUpdated(breadcrumbs: Breadcrumb[]) {
    this.breadcrumbs = breadcrumbs;
  }
}
